//INFO: Group in folder task. For sub task use prefix es SubTask.Edit.c.js
import task from "@commons/task";
import {sa2Toast, sa2Confirm, sa2Alert} from "@commons/sa2Custom";

var groupsElement = $("#groupId"); // Classe riferimento
var quantityElement = $("#prods-quantity");
var prodsContainer = $("#products");

(function () {

    if (!$(prodsContainer).length) {
        return;
    }

    var groupId = $(groupsElement).val();
    var quantity = $(quantityElement).val();
    var accountType = $(prodsContainer).data("accountType");
    //alert(accountType);

    $(groupsElement).change(function () {
        groupId = $(this).val();
        updatePrices();
    });

    $(quantityElement).change(function () {
        quantity = $(this).val();
        updatePrices();
    });

    function updateProdsDesc(products) {
        $.each(products, function (index, p) {
            var refId = "#prod-id-" + p.productId + " .prod-desc";
            $(refId).empty().html(p.priceDescription);
        });
    }

    function updatePrices() {

        if (!groupId) {
            groupId = null;
        }

        if (!quantity) {
            quantity = 1;
        }

        // Andrebbe disabilitato anche il submit

        $("#products .prod-item-variable .prod-desc")
                .empty()
                .html('<div class="prod-desc-loader"><span class="fa fa-spinner fa-spin"></span></div>');

        $.post(task("Register.prices"), {groupId: groupId, quantity: quantity, accountType: accountType}, function (response) {
            if (response.success) { //Prods data

                var prods = response.prods;

                if (prods.baseProducts) {
                    updateProdsDesc(prods.baseProducts.products);
                } else {
                    console.log("Missing baseProducts");
                }

                if (prods.insuranceProducts) {
                    updateProdsDesc(prods.insuranceProducts.products);
                } else {
                    console.log("Missing insuranceProducts");
                }

            } else {
                if (response.message) {
                    sa2Alert(response.message);
                }
            }

        }, 'json').fail(function (xhr, status, error) {
            alert(error);
        });
    }

    updatePrices();

})();


